import React, { useMemo, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import PageHero from "../../../components/PageHero";
import { marked } from "marked";

export default function NewsDetails({ siteContent }) {
  const [activeIndex, setActiveIndex] = useState(null);
  const { title, news, slug } = siteContent;

  const NEWS = news
  const { id } = useParams();
  const history = useHistory();

  const item = useMemo(() => NEWS.find((n) => n.id === id), [id]);
  const images = item?.galleryInformation.split("\n")

  const open = (index) => setActiveIndex(index);
  const close = () => setActiveIndex(null);

  const next = () => setActiveIndex((prev) => (prev + 1) % images.length);

  const prev = () => setActiveIndex((prev) => prev === 0 ? images.length - 1 : prev - 1);


  if (!item) {
    return (
      <main className="container main">
        <div className="card">
          <h2 className="card__title">Notícia não encontrada</h2>
          <button className="btn btn--primary" onClick={() => history.push(`/${slug}`)} type="button">
            Ver todas as notícias
          </button>
        </div>
      </main>
    );
  }

  return (
    <>
      <PageHero
        title={title}
        subtitle={item.title}
        img={item?.image?.url}
      />

      <main className="container main">
        <article className="read">
          <h2 className="read__title">{item.title}</h2>

          <div className="read__meta">
            {item.important && <span className="badge">Importante</span>}
            <span className="dot">•</span>
            <span className="date">{item.date.split("-").reverse().join("-")}</span>
          </div>

          <div className="read__content" dangerouslySetInnerHTML={{ __html: marked(item?.content?.markdown) }} />
          {item?.galleryInformation !== "" && (
            <>
              {/* GRID */}
              <div className="newsGallery">
                {images.map((img, i) => (
                  <div key={i} className="newsGallery__item" onClick={() => open(i)}>
                    <img src={img} alt={img.caption || ""} />
                  </div>
                ))}
              </div>

              {/* MODAL */}
              {activeIndex !== null && (
                <div className="lightbox" onClick={close}>
                  <button className="lightbox__close">✕</button>

                  <img
                    src={images[activeIndex]}
                    className="lightbox__image"
                    alt={activeIndex}
                    onClick={(e) => e.stopPropagation()}
                  />

                  <button className="lightbox__prev" onClick={(e) => { e.stopPropagation(); prev(); }}>
                    ‹
                  </button>

                  <button className="lightbox__next" onClick={(e) => { e.stopPropagation(); next(); }}>
                    ›
                  </button>
                </div>
              )}
            </>
          )}
          <div className="read__actions">
            <button className="btn btn--ghost" onClick={() => history.push("/noticias")} type="button">
              ← Ver todas as notícias
            </button>
          </div>
        </article>
      </main>
    </>
  );
}